import * as _ from "lodash"

import {
  ISearch,
  ISearchProfile,
  ISearchProvider,
  HorizAlignment,
  SearchProviderFieldType,
  ISearchProviderField, ISearchRequestSubset, ITree, IProfileFilter, ISearchSort
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"

import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";


const vWB_Bulk_Appr_Event_Fields: {[id:string]: ISearchProviderField } = {
  WB_PLAN_ID:             {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Plan WB Id',  columnResourceName: 'colPlanWBId',      alignment: HorizAlignment.Center}, domainOptions: { }},
  WB_TEVT_ID:             {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Event WB Id',  columnResourceName: 'colEventWBId',      alignment: HorizAlignment.Center}, domainOptions: { }},
  EVENT_ID:            {type: SearchProviderFieldType.string, renderOptions: {columnWidthCharacters: 8, columnName: 'Event Id',     columnResourceName: 'colEventId',        alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
  EVENT_NAME:          {type: SearchProviderFieldType.string, renderOptions: {columnWidthCharacters: 30, columnName: 'Event Name',   columnResourceName: 'colEventName',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
  TYPE_ID:          {type: SearchProviderFieldType.string, renderOptions: {columnWidthCharacters: 8, columnName: 'Event Type',           columnResourceName: 'colEventType',         alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
  LE_SPEND:          {type: SearchProviderFieldType.number,  renderOptions: {columnWidthCharacters: 8, columnName: 'LE Spend',        columnResourceName: 'colLESpend', alignment: HorizAlignment.Right, numberFormat: "#,##0.00"}, domainOptions: {}},
  PLANNED_SPEND:          {type: SearchProviderFieldType.number,  renderOptions: {columnWidthCharacters: 8, columnName: 'Planned Spend',        columnResourceName: 'colPlannedSpend', alignment: HorizAlignment.Right, numberFormat: "#,##0.00"}, domainOptions: {}},
  APPROVED_SPEND:          {type: SearchProviderFieldType.number,  renderOptions: {columnWidthCharacters: 8, columnName: 'Approved Spend',        columnResourceName: 'colApprovedSpend', alignment: HorizAlignment.Right, numberFormat: "#,##0.00"}, domainOptions: {}},
  STATUS_ID:           {type: SearchProviderFieldType.string,  renderOptions: {columnWidthCharacters: 10, columnName: 'Status ID',            columnResourceName: 'colStatusName', alignment: HorizAlignment.Left}, domainOptions: {}},
  STATUS_NAME:          {type: SearchProviderFieldType.string, renderOptions: {columnWidthCharacters: 10, columnName: 'Status',   columnResourceName: 'colEventName',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
  UNAPPROVED_SPEND_COUNT:          {type: SearchProviderFieldType.number,  renderOptions: {columnWidthCharacters: 8, columnName: 'Unapproved Tactics',           columnResourceName: 'colUnapprovedSpendCount', alignment: HorizAlignment.Right, numberFormat: "#,##0"}, domainOptions: {}},
  INSTORE_START_DT:     {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'InStore Start Dt',      columnResourceName: 'colInStoreStart',  alignment: HorizAlignment.Center, dateFormat: "MM-dd-yy" }, domainOptions: { }},
  INSTORE_END_DT:       {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'InStore End Dt',        columnResourceName: 'colInStoreEnd',    alignment: HorizAlignment.Center, dateFormat: "MM-dd-yy" }, domainOptions: { }},
  SHIPMENT_START_DT:    {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Shipment Start Dt',     columnResourceName: 'colShipmentStart', alignment: HorizAlignment.Center, dateFormat: "MM-dd-yy" }, domainOptions: { }},
  SHIPMENT_END_DT:      {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Shipment End Dt',       columnResourceName: 'colShipmentEnd',   alignment: HorizAlignment.Center, dateFormat: "MM-dd-yy" }, domainOptions: { }}
}

const vWB_Bulk_Appr_Event_KeyFields =
  {id:    'WB_TEVT_ID',
   id_ui: 'EVENT_ID',
   name:  'EVENT_NAME'}


class TPMBulkApprovalEventSearchByListSearchProvider
  implements  ISearchProvider {

  planWBId: number = 0

  constructor(aWB_PLAN_ID: number) {
    this.planWBId = aWB_PLAN_ID
  }

  get keyFields() {
    return vWB_Bulk_Appr_Event_KeyFields
  }

  get searchProviderFields() {
    return vWB_Bulk_Appr_Event_Fields
  }

  search(requestSpec: ISearchRequestSubset): Promise<any[]> {
    const self = this
    return new Promise<any[]>((resolve, error) => {

      requestSpec.where.WB_PLAN_ID = this.planWBId

      let findRequest = SearchUtils.makeSearchRequest(requestSpec,
          'vUI_TPM_Unapproved_Events', //
          self.searchProviderFields,
          [])

      PASearch.findByRequest(findRequest)
          .then((res: any[]) => {
            _.forEach(res, (aRes: any) => {
              aRes.LE_SPEND = parseFloat(aRes.LE_SPEND)
              aRes.APPROVED_SPEND = parseFloat(aRes.APPROVED_SPEND)
            })
            resolve(res)
          })
          .catch((err) => {
            error(err)
          })
    })

  }
}


class TPMBulkApprovalEventSearchByListSearchProfile
  implements  ISearchProfile {

  aSearchProvider: ISearchProvider = undefined

  profileId = "default"
  profileName = "AutoSearch Only"
  renderOptions = { ui5ResourceId: "TPMBulkApprovalEventSearchByListProfile" }

  profileFilter: IProfileFilter[] = []

  profileDisplayFields = [
    'STATUS_NAME','EVENT_ID','UNAPPROVED_SPEND_COUNT','EVENT_NAME', 'TYPE_ID',
    {columnTitle: "InStore Dates",   fields: ['INSTORE_START_DT','INSTORE_END_DT'], seperator: " - ",alignment: HorizAlignment.Center },
    {columnTitle: "Shipment Dates",   fields: ['SHIPMENT_START_DT','SHIPMENT_END_DT'], seperator: " - ",alignment: HorizAlignment.Center },
    ,'LE_SPEND','PLANNED_SPEND', 'APPROVED_SPEND',{columnTitle: "Lock", lockClass: "TPMEvent", lockIdFieldName: "WB_TEVT_ID", bDisplayLockIcon: true, bDisplayLockOwner:true}
  ]

  profileHyperlinkFields = ['EVENT_ID', 'UNAPPROVED_SPEND_COUNT']

  profileTreeIdDefault = "default"
  profileTrees: ITree[] = [
  ]

  // Do sorting last.. not necessary for phase 1
  profileSortIdDefault = ""    //string;
  profileSorts: ISearchSort[] = [] //ISearchSort[];


  constructor(aWB_PLAN_ID: number){
    this.aSearchProvider = new TPMBulkApprovalEventSearchByListSearchProvider(aWB_PLAN_ID)
  }

  get profileSearchProvider(){ return this.aSearchProvider }

}


export class TPMBulkApprovalEventSearchByList
  implements  ISearch {

  constructor(aWB_PLAN_ID: number, options?: any){
    this.searchProfiles = [ new TPMBulkApprovalEventSearchByListSearchProfile(aWB_PLAN_ID) ]
  }

  searchName = "Select Event(s)"
  renderOptions = { ui5ResourceId: "TPMBulkApprovalEventSearchByList"}
  searchProfileIdDefault = "default"
  searchProfiles: ISearchProfile[] = []
  autoSearch = true

}
